import { ApiService } from 'src/app/services/api.service';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material/dialog';
import { Inject } from '@angular/core';
import { EmailService } from "src/app/services/email-service";
import { MatSnackBar } from '@angular/material/snack-bar';
import { SessionService } from "src/app/services/session.service";
import moment from "moment";
import { firstValueFrom } from 'rxjs';
import { DialogService } from 'src/app/services/dialog.service';


@Component({
    selector: 'app-event-new',
    templateUrl: './event-new.component.html',
    styleUrls: ['./event-new.component.scss'],
    standalone: false
})
export class EventNewComponent implements OnInit {
  event: any
  @ViewChild('participantDialog') participantDialog!: TemplateRef<any>;
  username: any;
  object: any = Object;
  constructor(
    public dialogRef: MatDialogRef<EventNewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private apiService: ApiService,
    private emailService: EmailService,
    private sessionService: SessionService,
    private snackBar: MatSnackBar,
    private dialogService: DialogService
  ) {
    this.username = this.sessionService.getUsernameLocal();
  }

  searchTerm = '';
  selectedEmails = new Set<string>();
  participants = [
    { name: 'Sitaram Nelamangala', event_attendees_email: 'sitaram.nelamangala@dataunveil.com', role: 'Prescriber', icon: '🩺', color: '#00B894' },
    { name: 'Matt LaTronica', event_attendees_email: 'matt.latronica@dataunveil.com', role: 'Marketing', icon: '📢', color: '#e84393' },
    { name: 'Suresh Kumar', event_attendees_email: 'suresh.namburi@dataunveil.com', role: 'Operations', icon: '⚙️', color: '#636e72' },
    { name: 'Mohammed Arshad', event_attendees_email: 'mohammed.arshad@dataunveil.com', role: 'Case Manager', icon: '🗂️', color: '#d63031' },
    { name: 'Bhagyam Malla', event_attendees_email: 'bhagyam.malla@dataunveil.com', role: 'Caregiver', icon: '💜', color: '#6c5ce7' },
    { name: 'Tejaswi Potnuru', event_attendees_email: 'tejaswi.potnuru@dataunveil.com', role: 'Caregiver', icon: '💜', color: '#6c5ce7' },
    { name: 'Subash P', event_attendees_email: 'subash.p@dataunveil.com', role: 'Field Sales', icon: '📍', color: '#0984e3' },
    { name: 'Boopathi A', event_attendees_email: 'boopathi.a@dataunveil.com', role: 'Operations', icon: '⚙️', color: '#636e72' },
    { name: 'Raghuveer Reddy Kancherla', event_attendees_email: 'raghuveer.kancherla@dataunveil.com', role: 'Case Manager', icon: '🗂️', color: '#d63031' },
    { name: 'Dinesh Payasam', event_attendees_email: 'dinesh.payasam@dataunveil.com', role: 'Field Sales', icon: '📍', color: '#0984e3' },
    { name: 'Manikanta Veeragoni', event_attendees_email: 'manikanta.veeragoni@dataunveil.com', role: 'Field Sales', icon: '📍', color: '#0984e3' },
    { name: 'Usha Sree', event_attendees_email: 'usha.moosapeta@dataunveil.com', role: 'Field Sales', icon: '📍', color: '#00cec9' },
    { name: 'Aarti Goyal', event_attendees_email: 'aarti.goyal@dataunveil.com', role: 'Marketing', icon: '📢', color: '#e84393' },
  ];


ngOnInit(): void {
  this.username = this.sessionService.getUsernameLocal();
  this.event = (this.data.eventData && typeof this.data.eventData === 'object' && Object.keys(this.data.eventData).length)
    ? this.data.eventData
    : {
        event_name: '',
        type: 'Meeting',
        date: '',
        start_time: '',
        end_time: '',
        reminder: '5 Minutes Before',
        description: 'This is a scheduled event. Please find the details.',
        event_attendees: []
      };
}




  openDialog() {
    this.dialogRef = this.dialog.open(this.participantDialog, {
      width: '400px'
    });
  }

  // Dropdown options
  eventTypes = [
    { label: '🎥 Video Call', value: 'Video Call' },
    { label: '📞 Welcome Call', value: 'Welcome Call' },
    { label: '📋 Check-in', value: 'Check-in' },
    { label: '📅 Meeting', value: 'Meeting' }
  ];
  reminders = [
    '5 Minutes Before',
    '10 Minutes Before',
    '20 Minutes Before',
    '30 Minutes Before',
    '1 Hour Before',
    '2 Hour Before',
    '3 Hour Before',
  ];
  participantRoles = ['Prescriber', 'Operations', 'Case Manager', 'Caregiver'];

async createEvent(event: any, btn: any) {
  // Common: Prepare date/time strings
  const startDateTime = `${event.date}T${event.start_time}`;
  const endDateTime = `${event.date}T${event.end_time || event.start_time}`;

  if (btn === 'Update') {
    const graphEventId = event.graph_id || this.data?.rawData?.graph_id || sessionStorage.getItem('graph_id') || this.newEventId();

    let meetingLink = event.meeting_link || "";
    if (!meetingLink) {
      try {
        meetingLink = await this.resolveMeetingLink(event, startDateTime, endDateTime);
      } catch (err) {
        console.error("Error generating meeting link:", err);
      }
    }

    const attendees = this.attendeesForSave(event);
    const postdata = {
      ...event,
      start_date: event.date,
      end_date: event.date,
      event_created_by: this.username,
      event_created_dt: new Date(),
      meeting_link: meetingLink,
      graph_id: graphEventId,
      event_attendees: attendees,
    };
    this.event.event_attendees = attendees;
    this.event.meeting_link = meetingLink;

    this.apiService.addEvent(postdata).subscribe(
      async () => {
        await this.notifyAttendeesByEmail();
        this.snackBar.open('Event updated successfully!', 'Close', {
          duration: 3000,
          panelClass: ['success-snackbar'],
        });
        this.dialogRef.close({ success: true, graph_id: graphEventId });
      },
      (err: any) => {
        console.error('Error while saving event:', err);
        this.snackBar.open('Failed to save event to database.', 'Close', {
          duration: 3000,
          panelClass: ['error-snackbar'],
        });
        this.dialogRef?.close();
      }
    );

  } else {
    try {
      const graphEventId = this.newEventId();
      let meetingLink = event.meeting_link || "";
      if (!meetingLink) {
        try {
          meetingLink = await this.resolveMeetingLink(event, startDateTime, endDateTime);
        } catch (err) {
          console.error("Error generating meeting link:", err);
        }
      }

      const attendees = this.attendeesForSave(event);
      const postdata = {
        ...event,
        start_date: event.date,
        end_date: event.date,
        event_created_by: this.username,
        event_created_dt: new Date(),
        meeting_link: meetingLink,
        graph_id: graphEventId,
        event_attendees: attendees,
      };
      this.event.event_attendees = attendees;
      this.event.meeting_link = meetingLink;

      this.apiService.addEvent(postdata).subscribe(
        async () => {
          await this.notifyAttendeesByEmail();
          this.snackBar.open('Event created successfully!', 'Close', {
            duration: 3000,
            panelClass: ['success-snackbar'],
          });
          this.dialogRef.close({ success: true, graph_id: graphEventId });
        },
        (err: any) => {
          console.error('Error while saving event:', err);
          this.snackBar.open('Failed to save event to database.', 'Close', {
            duration: 3000,
            panelClass: ['error-snackbar'],
          });
        }
      );

    } catch (err) {
      console.error('Error creating event:', err);
      this.snackBar.open('Failed to create calendar event.', 'Close', {
        duration: 3000,
        panelClass: ['error-snackbar'],
      });
    }
  }
}


 // Close modal
  close() {
    console.log('Dialog closed.');
    // Trigger modal close (you’ll need to hook this into your modal system)
    // this.dialogRef.close();
  }

  // Optional: Add dynamic reminder
  addReminder() {
    console.log('Add reminder clicked.');
    // You could open a new sub-dialog or add a new entry dynamically
  }

  // Optional: Add dynamic participant
  addParticipants() {
    this.openDialog()
  }

  toggleSelection(email: string) {
    this.selectedEmails.has(email)
      ? this.selectedEmails.delete(email)
      : this.selectedEmails.add(email);
  }

  isSelected(email: string): boolean {
    return this.selectedEmails.has(email);
  }

  filteredParticipants(): any {
    return this.participants.filter((p: any) =>
      (p.name + p.event_attendees_email).toLowerCase().includes(this.searchTerm.toLowerCase())
    );
  }

  confirmSelection() {
    const selected = [...this.selectedEmails];
    this.event.event_attendees = selected
    this.dialogRef?.close();
  }
  private newEventId(): string {
    const random = typeof crypto !== "undefined" && crypto.randomUUID
      ? crypto.randomUUID()
      : `${Date.now()}`;
    return `scraii-${random}`;
  }

  private attendeesForSave(event: any): { event_attendees_email: string }[] {
    const emails = new Set<string>();
    if (this.username) emails.add(String(this.username).trim());
    for (const attendee of event.event_attendees || []) {
      const email = typeof attendee === "string"
        ? attendee
        : (attendee?.event_attendees_email || attendee?.email);
      if (email) emails.add(String(email).trim());
    }
    return [...emails].filter(Boolean).map((event_attendees_email) => ({ event_attendees_email }));
  }

  notifyAttendeesByEmail() {
    const toRecipients = (this.event.event_attendees || [])
      .map((attendee: any) => typeof attendee === "string" ? attendee : attendee?.event_attendees_email)
      .filter((email: string) => email && email !== this.username)
      .join(',');
    if (!toRecipients) return;
    const subject = `You're Invited: ${this.event.event_name} | SCRAII Events`;

    const message = `
  <div style="font-family: Arial, sans-serif; color: #333; line-height: 1.6;">
    <h2 style="color: #2c3e50;">You're Invited!</h2>
    <p>We’re excited to invite you to an upcoming event organized by <strong>SCRAII</strong>.</p>

    <p>
      <strong>📌 Event:</strong> ${this.event.event_name}<br>
      <strong>📅 Date:</strong> ${moment(this.event.start_date).format('dddd, MMMM D, YYYY')}<br>
      <strong>⏰ Time:</strong> ${this.event.start_time + ' - ' + this.event.end_time}<br>
      <strong>👤 Hosted by:</strong> ${this.username}
    </p>

    <p><strong>📝 Description:</strong> ${this.event.description}</p>
    <p></p>
    <p><strong>🔗 Meeting Link:</strong> <a href="${this.event.meeting_link}" target="_blank">${this.event.meeting_link}</a></p>
    ${this.event.meeting_code ? `<p><strong>Meeting code:</strong> ${this.event.meeting_code}</p>` : ""}
      <p style="margin-top: 20px;">
      Kindly save the date. We look forward to your participation and hope this session will be valuable to you.
    </p>

    <p style="margin-top: 20px;">Warm regards,<br><strong>SCRAII Events   </strong></p>
  </div>
`;
    const emailPayload = {
      to: toRecipients,
      subject: subject,
      htmlBody: message,
      attachments: [], // If needed
    };
    this.emailService.sendEmail(toRecipients, subject, message, [])
      .then(() => {
        this.snackBar.open('Email sent successfully!', 'Close', {
          duration: 3000, // Snackbar will be visible for 3 seconds
          panelClass: ['success-snackbar'], // Optional: Add custom styling
        });
      })
      .catch((error) => {
        console.error('Error sending email:', error);
        this.snackBar.open('Failed to send email. Please try again.', 'Close', {
          duration: 3000, // Snackbar will be visible for 3 seconds
          panelClass: ['error-snackbar'], // Optional: Add custom styling
        });
      });
  }

  waitClicks = false;
  async generateMeetingLink() {
    if (this.waitClicks) return;
    if (!this.event?.event_name?.trim() || !this.event?.date || !this.event?.start_time || !this.event?.end_time) {
      this.snackBar.open('Enter the event name, date, and times before generating a link.', 'Close', { duration: 4000 });
      return;
    }

    this.waitClicks = true;
    setTimeout(() => this.waitClicks = false, 5000);

    try {
      const startDateTime = `${this.event.date}T${this.event.start_time}`;
      const endDateTime = `${this.event.date}T${this.event.end_time}`;
      this.event.meeting_link = "";
      this.event.meeting_link = await this.resolveMeetingLink(this.event, startDateTime, endDateTime);
      this.snackBar.open('Meeting link generated.', 'Close', { duration: 3000 });
    } catch (error: any) {
      console.error('Generate meeting link failed', error);
      const message = error?.error?.message || 'Failed to generate the meeting link.';
      this.snackBar.open(message, 'Close', { duration: 5000 });
    }
  }

  private videoPayload(event: any) {
    const start = new Date(`${event.date}T${event.start_time}`);
    const end = event.end_time
      ? new Date(`${event.date}T${event.end_time}`)
      : new Date(start.getTime() + 30 * 60000);
    return {
      title: event.event_name || "Video Call",
      description: event.description,
      startUtc: start.toISOString(),
      endUtc: end.toISOString(),
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      recipients: (event.event_attendees || []).map((attendee: any) => {
        const email = typeof attendee === "string" ? attendee : (attendee?.event_attendees_email || attendee?.email);
        return { email, displayName: attendee?.name || email };
      }),
    };
  }

  private async resolveMeetingLink(event: any, startDateTime: string, endDateTime: string): Promise<string> {
    if (event.meeting_link) return event.meeting_link;
    const start = new Date(startDateTime);
    const end = new Date(endDateTime);
    if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime()) || end <= start) {
      throw { error: { message: 'The end time must be after the start time.' } };
    }
    const scheduled: any = await firstValueFrom(this.apiService.scheduleVideoMeeting(this.videoPayload(event)));
    const link = scheduled?.joinUrl;
    if (!link) throw { error: { message: 'The meeting service did not return a link.' } };
    event.meeting_code = scheduled.publicCode;
    event.meeting_link = link;
    return link;
  }




}